import { useMemo, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { TrackingApi } from 'api/TrackingApi';
import {
  buildNewLandingUrl,
  getLandingIdFromUrl,
  getStepFromUrl,
  isNonPopunderLanding,
  isPrelandPage,
} from 'helpers/route';
import { useLandingPopunderQuery } from 'hooks/queries/useLandingPopunderQuery';
import {
  QueryKeys,
  useSystemSearchQueries,
} from 'hooks/useSystemSearchQueries';

import { useInitialId } from './useInitialId';

enum PopunderModes {
  Disabled,
  ForAllUsers,
  ForNotNewUsers,
}

export const useLandingPopunder = (isLandingInitLoad: boolean) => {
  const { pathname, search } = useLocation();
  const history = useHistory();

  const { getInitialIdFromCookie } = useInitialId();

  const { getPopunderQuery, getPartnerLoginIdQuery } = useSystemSearchQueries();

  const { value: popunderQuery, key: popunderQueryKey } = getPopunderQuery();
  const { value: partnerLoginQuery, key: partnerLoginKey } =
    getPartnerLoginIdQuery();

  const isNewUser = useRef(!getInitialIdFromCookie());

  const screenNumber = useMemo(() => getStepFromUrl(pathname) || 1, [pathname]);
  const prelandId = useMemo(
    () => getLandingIdFromUrl(pathname) || 1,
    [pathname]
  );

  const isPopunderEnabled = useMemo(
    () =>
      (isPrelandPage(pathname) &&
        !isNonPopunderLanding(pathname) &&
        Number(popunderQuery) === PopunderModes.ForAllUsers) ||
      (Number(popunderQuery) === PopunderModes.ForNotNewUsers &&
        !isNewUser.current),
    [pathname, popunderQuery]
  );

  useLandingPopunderQuery({
    enabled: isPopunderEnabled && isLandingInitLoad,
    onSuccess: (data) => {
      const {
        add_params: { event_data_id },
      } = data;

      if (!partnerLoginQuery) {
        const queries = {
          ...queryString.parse(search),
          [partnerLoginKey]: 63,
          [QueryKeys.EventDataId]: event_data_id,
        };

        history.replace({
          pathname,
          search: queryString.stringify(queries),
        });
      }

      window.document.body.addEventListener(
        'click',
        (e: any) => {
          e.stopPropagation();

          const newWindow = window.open();

          const queries = queryString.parse(search);

          delete queries[popunderQueryKey];

          const mergedQueries = {
            ...queries,
            ...data.add_params,
            ...{ [QueryKeys.PushRetry]: 1 },
          };

          const url = buildNewLandingUrl({
            pathname,
            search: queryString.stringify(mergedQueries),
            step: 2,
          });

          TrackingApi.logRegistrationStep({
            prelandId,
            screenNumber,
          }).then(() => {
            newWindow?.location?.replace(url);
            window.location.href = data.redirect_url;
          });
        },
        true
      );
    },
  });
};
